<template>
  <div style="height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "courseTeacherHome"
}
</script>

<style scoped>

</style>
